var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('EarningSearch'), _c('b-table', {
    ref: "table",
    staticClass: "card-table pb-4",
    staticStyle: {
      "max-height": "calc(100vh - 30vh) !important"
    },
    attrs: {
      "responsive": "",
      "select-mode": "single",
      "fields": _vm.headers,
      "items": _vm.filteredItems,
      "sticky-header": "",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(doctor)",
      fn: function (row) {
        return [_vm._v(" Dr. " + _vm._s(row.item.firstname) + " " + _vm._s(row.item.lastname) + " ")];
      }
    }, {
      key: "cell(billing-period)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(_vm.getBillingPeriodString(row.item.month, row.item.year)) + " ")];
      }
    }, {
      key: "cell(new-patients)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.patients.new) + " ")];
      }
    }, {
      key: "cell(transferred-patients)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.patients.transferfollowup) + " ")];
      }
    }, {
      key: "cell(message-adjusted)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.earning.v2.all.patientMessages) + " ")];
      }
    }, {
      key: "cell(ten-week-followups)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.patients.followuptenweek || 0) + " ")];
      }
    }, {
      key: "cell(one-year-followups)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.patients.followuponeyear || 0) + " ")];
      }
    }, {
      key: "cell(total-followups)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.patients.followup || 0) + " ")];
      }
    }, {
      key: "cell(grand-total-v1)",
      fn: function (row) {
        return [_vm._v(" $" + _vm._s(_vm.formatCurrency(row.item.earning.total)) + " ")];
      }
    }, {
      key: "cell(total-unique-patients-interaction)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.earning.v2.all.totalInteractions) + " ")];
      }
    }, {
      key: "cell(grand-total-v2)",
      fn: function ({
        item
      }) {
        return [_vm._v(" $" + _vm._s(_vm.formatCurrency(item.earning.v2.all.totalInteractions * item.earning.v2.all.price)) + " ")];
      }
    }, {
      key: "cell(grand-total-v2-california)",
      fn: function ({
        item
      }) {
        return [_vm._v(" $" + _vm._s(_vm.formatCurrency(item.earning.v2.ca.totalInteractions * item.earning.v2.ca.price)) + " ")];
      }
    }, {
      key: "cell(grand-total-v2-new-jersey)",
      fn: function ({
        item
      }) {
        return [_vm._v(" $" + _vm._s(_vm.formatCurrency(item.earning.v2.nj.totalInteractions * item.earning.v2.nj.price)) + " ")];
      }
    }, {
      key: "cell(grand-total-v2-excluding-ca-nj)",
      fn: function ({
        item
      }) {
        return [_vm._v(" $" + _vm._s(_vm.formatCurrency(item.earning.v2.non_ca_nj.totalInteractions * item.earning.v2.non_ca_nj.price)) + " ")];
      }
    }])
  }), _c('div', {
    staticClass: "tw-grid tw-grid-rows-1 tw-gap-x-2 tw-bg-[#f4f7f8] tw-px-4 tw-py-5",
    style: {
      [`grid-template-columns`]: `repeat(${_vm.headers.length}, 1fr)`
    }
  }, [_c('div', {
    staticClass: "tw-col-span-2"
  }, [_vm._v(" Total ")]), _c('div', {
    staticClass: "tw-col-span-1"
  }, [_vm._v(" " + _vm._s(_vm.totals.totalPatients) + " ")]), !_vm.hideV1Earnings ? _c('div', {
    staticClass: "tw-col-span-1"
  }, [_vm._v(" " + _vm._s(_vm.totals.totalTransferPatients) + " ")]) : _vm._e(), _c('div', {
    staticClass: "tw-col-span-1"
  }, [_vm._v(" " + _vm._s(_vm.totals.totalPatientsMessageAdjusted) + " ")]), _c('div', {
    staticClass: "tw-col-span-1"
  }, [_vm._v(" " + _vm._s(_vm.totals.totalTenWeek) + " ")]), _c('div', {
    staticClass: "tw-col-span-1"
  }, [_vm._v(" " + _vm._s(_vm.totals.totalOneYear) + " ")]), _c('div', {
    staticClass: "tw-col-span-1"
  }, [_vm._v(" " + _vm._s(_vm.totals.totalFollowups) + " ")]), !_vm.hideV1Earnings ? _c('div', {
    staticClass: "tw-col-span-1 tw-ml-1"
  }, [_vm._v(" $" + _vm._s(_vm.formatCurrency(_vm.totals.grandTotal)) + " ")]) : _vm._e(), _c('div', {
    staticClass: "tw-col-span-1 tw-ml-1"
  }, [_vm._v(" " + _vm._s(_vm.totals.totalUniquePatientsInteraction) + " ")]), _c('div', {
    staticClass: "tw-col-span-1 tw-ml-1"
  }, [_vm._v(" $" + _vm._s(_vm.formatCurrency(_vm.totals.grandTotalV2)) + " ")]), _c('div', {
    staticClass: "tw-col-span-1 tw-ml-1"
  }, [_vm._v(" $" + _vm._s(_vm.formatCurrency(_vm.totals.grandTotalV2California)) + " ")]), _c('div', {
    staticClass: "tw-col-span-1 tw-ml-1"
  }, [_vm._v(" $" + _vm._s(_vm.formatCurrency(_vm.totals.grandTotalV2NewJersey)) + " ")]), _c('div', {
    staticClass: "tw-col-span-1 tw-ml-1"
  }, [_vm._v(" $" + _vm._s(_vm.formatCurrency(_vm.totals.grandTotalV2ExcludingCaNj)) + " ")])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };